import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

const fontSizes = {
	xs: "0.85rem",
	sm: "0.975rem",
	md: "1.1rem",
	lg: "1.225rem",
	xl: "1.35rem",
	"2xl": "1.6rem",
	"3xl": "1.975rem",
	"4xl": "2.35rem",
	"5xl": "3.1rem",
	"6xl": "3.85rem",
	"7xl": "4.6rem",
	"8xl": "7rem",
	"9xl": "9rem",
};

const theme = extendTheme({
	fontSizes,
	styles: {
		global: {
			"*": {
				tapHighlightColor: "transparent",
				WebkitTapHighlightColor: "transparent",
			},
		},
	},
});

ReactDOM.render(
	<React.StrictMode>
		<ChakraProvider theme={theme} resetCss>
			<App />
		</ChakraProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
